import { useTranslation } from 'react-i18next';

import type { LayerState } from '@/api/generated/schemas';
import { Badge } from '@/shared/ui';
import { SERIE_STATE_TONE, toSerieStateKey } from '../../internal/serieLayers';

interface SerieStateBadgeProps {
  state: LayerState;
}

/**
 * Stavový badge vrstvy (sloupce tabulky termínů). Jediný zdroj mapování stav → tón + lokalizovaný popis.
 */
export function SerieStateBadge({ state }: SerieStateBadgeProps) {
  const { t } = useTranslation('venua-planner');
  const key = toSerieStateKey(state);
  return (
    <Badge tone={SERIE_STATE_TONE[key]} appearance="soft">
      {t(`serieDetail.states.${key}`)}
    </Badge>
  );
}
